<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-5">
                <b-field>
                    <b-input :placeholder="$t('TIPOLOCAISLISTA.PROCURAR')"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column">
                <div class="buttons">
                    <router-link :to="{ name: 'tipodelocal' }" class="button is-primary">
                        {{$t('TIPOLOCAISLISTA.INCLUIR')}}
                    </router-link>
                </div>
            </div>
            <div class="column is-2">
                <form @submit.prevent="abrirCadastroInput">
                    <b-field>
                        <b-input :placeholder="$t('TIPOLOCAISLISTA.CODIGO')"
                                 v-model="id"
                                 type="number"
                                 icon-right="edit"
                                 icon-right-clickable
                                 @icon-right-click="abrirCadastroInput">
                        </b-input>
                    </b-field>
                </form>
            </div>
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 paginated
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 :aria-next-label="$t('TIPOLOCAISLISTA.PROXPAG')"
                 :aria-previous-label="$t('TIPOLOCAISLISTA.PAGANTERIOR')"
                 :aria-page-label="$t('TIPOLOCAISLISTA.PAGINA')"
                 :aria-current-label="$t('TIPOLOCAISLISTA.PAGATUAL')">

            <template >
                <b-table-column v-slot="props" field="id" :label="$t('TIPOLOCAISLISTA.CODIGO')">
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column v-slot="props" field="Nome" :label="$t('TIPOLOCAISLISTA.NOME')">
                    {{ props.row.nome }}
                </b-table-column>

                <b-table-column v-slot="props" field="acidenteOcupacional" :label="$t('TIPOLOCAISLISTA.ACIDENTE')">
                    <b-icon v-show="props.row.acidenteOcupacional" icon="check-circle"></b-icon>
                </b-table-column>

                <b-table-column v-slot="props" field="coletaDomiciliar" :label="$t('TIPOLOCAISLISTA.COLETADOM')">
                    <b-icon v-show="props.row.coletaDomiciliar" icon="check-circle"></b-icon>
                </b-table-column>

                <b-table-column v-slot="props" custom-key="actions" numeric>
                    <router-link :to="{ name: 'tipodelocal', params: { id: props.row.id }}" class="button is-small is-primary" :title="$t('TIPOLOCAISLISTA.EDITAR')">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'
    import titlebar from '@/components/titlebar.vue'

    export default {
        data() {
            return {
                model: [],
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? "",
                ordenarPor: 'Nome',
                ordenar: 'asc',
                defaultOrdenar: 'asc',
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null
            }
        },
        components: {
            titlebar
        },
        computed: {
            titleStack() {
                return [
                    this.$t('TIPOLOCAISLISTA.MANUTENCAO'),
                    this.$t('TIPOLOCAISLISTA.TIPOLOCAL'),
                ]
            },
            ...mapGetters([
                'isInRole'
            ])
        },
        methods: {
           loadAsyncData() {
                const params = [
                    `procurar=${this.procurar}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`,
                    `perPage=${this.perPage}`
                ].join('&')

                this.loading = true
                this.$http.get(`/api/manutencao/tiposdelocais?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastroInput() {
                this.$router.push({ path: `/manutencao/tipodelocal/${this.id}` })
            },
        },
        mounted() {
            this.loadAsyncData()
        }
    }
</script>